"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    expansionPanelSummaryContent: {
      '& > :last-child': {
        paddingRight: '0'
      },
      margin: '0 0'
    },
    expanderExpanded: {
      margin: '0 0',
      '&.Mui-expanded': {
        margin: '0 0'
      }
    },
    expanderRoot: {
      boxShadow: 'none',
      margin: '0 0',
      height: 'auto',
      position: 'relative',
      left: 1,
      bottom: 1,
      '&:before': {
        backgroundColor: theme.palette.common.white
      }
    },
    iconRoot: {
      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexGrow: 0,
      '&.rotated': {
        transform: 'rotate(180deg)'
      }
    },
    buttonContainer: {
      width: 32,
      display: 'flex'
    },
    buttonSubContainer: {
      width: '100%',
      alignSelf: 'center',
      textAlign: 'center'
    },
    buttonRoot: {
      backgroundColor: 'transparent',
      padding: '0',
      flexGrow: 0
    },
    headerTypographyRoot: function headerTypographyRoot(props) {
      return {
        flexGrow: 1,
        alignSelf: 'center',
        paddingLeft: props.arrowRight && (props.contentOffset === undefined || props.contentOffset) ? 10 : 0
      };
    },
    content: function content(props) {
      return {
        padding: '0 0',
        '&.offset': {
          paddingLeft: props.arrowRight ? 10 : 32
        }
      };
    },
    expansionPanelSummaryRoot: {
      padding: '0 0',
      minHeight: 0,
      display: 'flex',
      '&.Mui-expanded': {
        minHeight: 0
      }
    },
    expansionPanelSummaryExpanded: {
      '&.Mui-expanded': {
        margin: '0 0'
      },
      margin: '0 0'
    }
  };
};

exports.default = _default;